import { Icon, IconName } from "../icons/Icon";

interface IconButtonProps {
    onClick: () => void;
    icon: IconName;
    disabled?: boolean;
    width?: number;
}

export const IconButton = ({
    onClick,
    icon,
    disabled,
    width = 12,
}: IconButtonProps) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    };

    return (
        <div
            className={`relative button-icon ${disabled ? "disabled" : ""}`}
            onClick={disabled ? undefined : handleClick}
        >
            <Icon name={icon as IconName} width={width} />
        </div>
    );
};
